export function getPropertyOfObject<T, K extends keyof T>(obj: T, key: string) {
    return obj[key as K]
  }
  